<template>
  <!-- BEGIN pos-counter-body -->
  <div class="pos-counter-body">
    <!-- Table Content Component -->
    <PosCounterContent :tableLists="tableLists" :tableFetching="tableFetching" :selected_table="selected_table"
      @onTableSelected="$emit('onTableSelected', $event)" @onMemberCheckout="$emit('onMemberCheckout', $event)"
      @check-in="$emit('check-in', $event)"
      @pick-invoice="$emit('pick-invoice', $event)" />

    <!-- Sidebar Component -->
    <PosCounterSidebar :tableSelected="tableSelected" :posMobileSidebar="posMobileSidebar"
      :defaultCrrency="defaultCrrency" :vatRate="vatRate" :printing="printing"
      @posMobileSidebarToggled="$emit('posMobileSidebarToggled')" @removeItem="$emit('removeItem', $event)"
      @showCombineTableForm="$emit('showCombineTableForm')" @moveTable="$emit('moveTable')"
      @cleanTable="$emit('cleanTable')" @cancelOrder="$emit('cancelOrder')" @addMoreOrder="$emit('addMoreOrder')"
      @printBill="$emit('printBill')" @showBillForm="$emit('showBillForm')"
      @showShiftCloseForm="$emit('showShiftCloseForm')" @splitBill="$emit('splitBill')"
      @onTableSelected="$emit('onTableSelected', $event)" @fetchTableByInterval="$emit('fetchTableByInterval', $event)"
      @showQueueListForm="$emit('showQueueListForm')" @showMemberCardForm="$emit('showMemberCardForm')"
      @showInvoiceListForm="$emit('showInvoiceListForm')"
      @openPaymentMethodSelection="$emit('openPaymentMethodSelection')" />
  </div>
  <!-- END pos-counter-body -->
</template>

<script>
import PosCounterContent from './PosCounterContent.vue'
import PosCounterSidebar from './PosCounterSidebar.vue'

export default {
  name: 'PosCounterBody',
  components: {
    PosCounterContent,
    PosCounterSidebar
  },
  props: {
    tableLists: {
      type: Array,
      default: () => []
    },
    tableFetching: {
      type: Boolean,
      default: false
    },
    selected_table: {
      type: Number,
      default: 0
    },
    tableSelected: {
      type: Object,
      default: () => ({})
    },
    posMobileSidebar: {
      type: Boolean,
      default: false
    },
    defaultCrrency: {
      type: String,
      default: ''
    },
    vatRate: {
      type: Number,
      default: 0
    },
    printing: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
@media (max-width: 991.98px) {
  .pos-counter .pos-counter-body {
    height: calc(100%);
  }
}
</style>
